(() => {
  const selector = '[data-linephra-chat-open]';
  const wireButton = () => {
    const trigger = document.querySelector(selector);
    if (!trigger || trigger.dataset.linephraChatReady === 'true') return;
    trigger.dataset.linephraChatReady = 'true';
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const runtime = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('shopify-agent-runtime');
      if (typeof runtime?.show === 'function') runtime.show({});
      else runtime?.shadowRoot?.querySelector('[part="activator"]')?.click();
    });
  };
  wireButton();
  document.addEventListener('DOMContentLoaded', wireButton, { once: true });
})();
